import React, { useState, useEffect, useContext, useRef } from "react";
import { Link } from "gatsby";

// Components //
import ContainerFilter from "../../atoms/container-filter";
import RadioFilterEnctal from "../../atoms/radio-filter-enctal/radio-filter-enctal";
import CheckboxFilterEnctal from "../../atoms/checkbox-filter-enctal/checkbox-filter-enctal";
import Box from '@mui/material/Box';
import Slider from '@mui/material/Slider';
import { styled } from '@mui/system';
import Button from "../../atoms/button/button";

// Context //
import TalentsContext from "../../../contexts/talentsContext";

// Styles //
import "./listFiltersEncTal.scss";

// Helpers //
import { removeCheckedRadio, removeChecked } from "../../../utils/helpers";

interface ListFiltersEncTalProps {
    name?: string;
    id?: number;
    region?: string;
    idRegion?: number;
    handleFilters: () => void;
}

const ListFiltersEncTal = (props: ListFiltersEncTalProps) => {
    const { handleFilters } = props;
    const { filterCatalogData, initialSelectedFilters, selectedFilters, setSelectedFilters } = useContext(TalentsContext);

    const [openedFilter, setOpenedFilter] = useState<number>(-1);
    const [keys, setKeys] = useState<any>([]);

    const wrapFilter = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const keysAux = filterCatalogData ? Object.keys(filterCatalogData) : [];
        setKeys(keysAux);
    }, [filterCatalogData]);

    const handleToggleFilter = (index) => {
        if (openedFilter === index) {
            setOpenedFilter(-1);
            return;
        }
        setOpenedFilter(index);
        if (index == 1 || index == 7) {
            wrapFilter.current?.scrollIntoView({
                behavior: "smooth",
            });
        } else if (index === 2 || index === 4 || index === 6) {
            wrapFilter.current?.scrollIntoView({
                behavior: "smooth",
                block: "center",
            });
        }
    };

    // TODO - filtros
    const [selectedRegion, setSelectedRegion] = useState(null);
    const onHandleRadio = (e) => {
        const { value, checked, name } = e.target;
        if (checked) {
            if (name === "region") {
                let auxSelectedFilters = {...selectedFilters};
                auxSelectedFilters["region"] = { items: [] };
                setSelectedFilters({
                    ...auxSelectedFilters,
                    region: {
                        items: [
                            ...auxSelectedFilters.region.items,
                            {
                                label: e.target.dataset.label,
                                value: value,
                                name: name,
                            },
                        ],
                    },
                });
                e.target.classList.add("active");
                setSelectedRegion(value);
            }
            if (name === "city") {
                let auxSelectedFilters = {...selectedFilters};
                auxSelectedFilters["city"] = { items: [] };
                setSelectedFilters({
                    ...auxSelectedFilters,
                    city: {
                        items: [
                            ...auxSelectedFilters.city.items,
                            {
                                label: e.target.dataset.label,
                                value: value,
                                name: name,
                            },
                        ],
                    },
                });
                e.target.classList.add("active");
            }
            if (name === "language") {
                let auxSelectedFilters = {...selectedFilters};
                auxSelectedFilters["language"] = { items: [] };
                setSelectedFilters({
                    ...auxSelectedFilters,
                    language: {
                        items: [
                            ...auxSelectedFilters.language.items,
                            {
                                label: e.target.dataset.label,
                                value: value,
                                name: name,
                            },
                        ],
                    },
                });
                e.target.classList.add("active");
            }
        }
    };

    const onHandleCheck = (e) => {
        const { value, checked, name } = e.target;
        if (checked) {
            if (name === "educationLevel") {
                setSelectedFilters({
                    ...selectedFilters,
                    educationLevel: {
                        values: [...selectedFilters.educationLevel.values, value],
                        items: [
                            ...selectedFilters.educationLevel.items,
                            {
                                label: e.target.dataset.label,
                                value: value,
                                name: name,
                            },
                        ],
                    },
                });
                e.target.classList.add("active");
            }
            if (name === "profession") {
                setSelectedFilters({
                    ...selectedFilters,
                    profession: {
                        values: [...selectedFilters.profession.values, value],
                        items: [
                            ...selectedFilters.profession.items,
                            {
                                label: e.target.dataset.label,
                                value: value,
                                name: name,
                            },
                        ],
                    },
                });
                e.target.classList.add("active");
            }
            if (name === "area") {
                setSelectedFilters({
                    ...selectedFilters,
                    area: {
                        values: [...selectedFilters.area.values, value],
                        items: [
                            ...selectedFilters.area.items,
                            {
                                label: e.target.dataset.label,
                                value: value,
                                name: name,
                            },
                        ],
                    },
                });
                e.target.classList.add("active");
            }
            if (name === "populationGroup") {
                setSelectedFilters({
                    ...selectedFilters,
                    populationGroup: {
                        values: [...selectedFilters.populationGroup.values, value],
                        items: [
                            ...selectedFilters.populationGroup.items,
                            {
                                label: e.target.dataset.label,
                                value: value,
                                name: name,
                            },
                        ],
                    },
                });
                e.target.classList.remove("active");
            }
        //Remueve los filtros en forma de caja verde
        } else {
            if (name === "educationLevel") {
                setSelectedFilters({
                    ...selectedFilters,
                    educationLevel: {
                        values: selectedFilters.educationLevel.values.filter(
                            (e) => e !== value
                        ),
                        items: selectedFilters.educationLevel.items.filter(
                            (e) => e.value !== value
                        ),
                    },
                });
                e.target.classList.remove("active");
            }
            if (name === "profession") {
                setSelectedFilters({
                    ...selectedFilters,
                    profession: {
                        values: selectedFilters.profession.values.filter(
                            (e) => e !== value
                        ),
                        items: selectedFilters.profession.items.filter(
                            (e) => e.value !== value
                        ),
                    },
                });
                e.target.classList.remove("active");
            }
            if (name === "area") {
                setSelectedFilters({
                    ...selectedFilters,
                    area: {
                        values: selectedFilters.area.values.filter(
                            (e) => e !== value
                        ),
                        items: selectedFilters.area.items.filter(
                            (e) => e.value !== value
                        ),
                    },
                });
                e.target.classList.remove("active");
            }
            if (name === "populationGroup") {
                setSelectedFilters({
                    ...selectedFilters,
                    populationGroup: {
                        values: selectedFilters.populationGroup.values.filter(
                            (e) => e !== value
                        ),
                        items: selectedFilters.populationGroup.items.filter(
                            (e) => e.value !== value
                        ),
                    },
                });
                e.target.classList.remove("active");
            }
        }
    };

    const [langLevel, setLangLevel] = useState(0);
    const [langLevelDisabled, setLangLevelDisabled] = useState(true);
    const onHandleChangeLangLevel = (e, newval) => {
        const updatedValue = newval + 1;
        let auxSelectedFilters = {...selectedFilters};
        auxSelectedFilters["languageLevel"] = { items: [] };
        setLangLevel(newval);
        setSelectedFilters({
            ...auxSelectedFilters,
            languageLevel: {
                items: [
                    ...auxSelectedFilters.languageLevel.items,
                    {
                        label: filterCatalogData.languageLevel.filter((level) => level.id == updatedValue)[0].desc,
                        value: updatedValue,
                        name: "languageLevel",
                    },
                ],
            },
        });
    }

    useEffect(() => {
        if (selectedFilters.language.items.length == 0) {
            setLangLevel(0);
            setLangLevelDisabled(true);
        }
        else {
            setLangLevelDisabled(false);
        }
    }, [selectedFilters]);

    const StyledSlider = styled(Slider)({
        "& .MuiSlider-rail": {
            backgroundColor: '#D4D6D6',
            borderRadius: '6px',
            height: '7px',
            opacity: '1',
            '@media (max-width: 768px)': {
                width: '280px',
            }
        },
        "& .MuiSlider-track": {
            borderRadius: '6px',
            height: '7px',
            backgroundColor: '#EE2B7B',
            border: '0px',
        },
        "& .MuiSlider-mark": {
            backgroundColor: 'transparent',
        },
        "& .MuiSlider-thumb": {
            width: '19px',
            height: '19px',
            backgroundColor: '#EE2B7B',
        },
    });

    return (
        <div className="list-filters-enc-tal" ref={wrapFilter}>
            <div className="list-filters-enc-tal__inner">
                <span className="list-filters-enc-tal__close" onClick={handleFilters}>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="15.536"
                        height="15.536"
                        viewBox="0 0 15.536 15.536"
                    >
                        <g id="x" transform="translate(1.768 1.768)">
                            <line
                                id="Línea_80"
                                data-name="Línea 80"
                                x1="12"
                                y2="12"
                                fill="none"
                                stroke="#303030"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2.5"
                            />
                            <line
                                id="Línea_81"
                                data-name="Línea 81"
                                x2="12"
                                y2="12"
                                fill="none"
                                stroke="#303030"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2.5"
                            />
                        </g>
                    </svg>
                </span>
                <p className="list-filters-enc-tal__title">Filtrar por:</p>
                {keys.map((key, index) => {
                    if (key === "region") {
                        return (
                            <ContainerFilter
                                key={index}
                                className={key}
                                title="Región"
                                active={openedFilter === index}
                                onToggle={() => handleToggleFilter(index)}
                            >
                                {filterCatalogData?.region?.map(
                                    (
                                        { id, desc},
                                        index
                                    ) => (
                                        <RadioFilterEnctal
                                            id={id}
                                            label={desc}
                                            name="region"
                                            value={id}
                                            key={index}
                                            handleChange={onHandleRadio}
                                        />
                                    )
                                )}
                            </ContainerFilter>
                        );
                    }
                    if (key === "city") {
                        return (
                            <ContainerFilter
                                key={index}
                                className={key}
                                title="Ciudad o municipio"
                                active={openedFilter === index}
                                onToggle={() => handleToggleFilter(index)}
                            >
                                {filterCatalogData?.city.map(
                                    (
                                        { subregion, id, desc, idAira, descAira },
                                        index
                                    ) => {
                                        if (selectedRegion == null || (selectedRegion != null && subregion.id == selectedRegion)) {
                                            return <RadioFilterEnctal
                                                id={idAira}
                                                label={desc}
                                                name="city"
                                                value={id}
                                                key={index}
                                                handleChange={onHandleRadio}
                                            />
                                            }
                                        return <></>
                                    }
                                )}
                            </ContainerFilter>
                        );
                    }
                    if (key === "educationLevel") {
                        return (
                            <ContainerFilter
                                key={index}
                                className={key}
                                title="Nivel educativo"
                                active={openedFilter === index}
                                onToggle={() => handleToggleFilter(index)}
                            >
                                {filterCatalogData?.educationLevel.map(
                                    (
                                        { id, desc, idAira, descAira },
                                        index
                                    ) => (
                                        <CheckboxFilterEnctal
                                            id={idAira}
                                            label={desc}
                                            name="educationLevel"
                                            value={id}
                                            handleChange={onHandleCheck}
                                            key={index}
                                        />
                                    )
                                )}
                            </ContainerFilter>
                        );
                    }
                    if (key === "profession") {
                        const sortedProfession = filterCatalogData?.profession?.slice().sort((a, b) => a.desc.localeCompare(b.desc));
                        return (
                            <ContainerFilter
                                key={index}
                                className={key}
                                title="Profesión"
                                active={openedFilter === index}
                                onToggle={() => handleToggleFilter(index)}
                            >
                                {sortedProfession.map(
                                    (
                                        { id, desc, idAira, descAira },
                                        index
                                    ) => (
                                        <CheckboxFilterEnctal
                                            id={idAira}
                                            label={desc}
                                            name="profession"
                                            value={id}
                                            handleChange={onHandleCheck}
                                            key={index}
                                        />
                                    )
                                )}
                            </ContainerFilter>
                        );
                    }
                    if (key === "area") {
                        return (
                            <ContainerFilter
                                key={index}
                                className={key}
                                title="Área de experiencia"
                                active={openedFilter === index}
                                onToggle={() => handleToggleFilter(index)}
                            >
                                {filterCatalogData?.area.map(
                                    (
                                        { id, desc, idAira, descAira },
                                        index
                                    ) => (
                                        <CheckboxFilterEnctal
                                            id={idAira}
                                            label={desc}
                                            name="area"
                                            value={id}
                                            handleChange={onHandleCheck}
                                            key={index}
                                        />
                                    )
                                )}
                            </ContainerFilter>
                        );
                    }
                    if (key === "populationGroup") {
                        return (
                            <ContainerFilter
                                key={index}
                                className={key}
                                title="Grupo poblacional"
                                active={openedFilter === index}
                                onToggle={() => handleToggleFilter(index)}
                            >
                                {filterCatalogData?.populationGroup.map(
                                    (
                                        { id, desc },
                                        index
                                    ) => (
                                        <CheckboxFilterEnctal
                                            id={`popGroup_${id}`}
                                            label={desc}
                                            name="populationGroup"
                                            value={id}
                                            handleChange={onHandleCheck}
                                            key={index}
                                        />
                                    )
                                )}
                            </ContainerFilter>
                        );
                    }
                    if (key === "language") {
                        return (
                            <ContainerFilter
                                key={index}
                                className={key}
                                title="Idioma"
                                active={openedFilter === index}
                                onToggle={() => handleToggleFilter(index)}
                            >
                                {filterCatalogData?.language.map(
                                    (
                                        { id, desc, idAira, descAira },
                                        index
                                    ) => (
                                        <RadioFilterEnctal
                                            id={idAira}
                                            label={desc}
                                            name="language"
                                            value={id}
                                            key={index}
                                            handleChange={onHandleRadio}
                                        />
                                    )
                                )}

                                <div className="slider__title">Nivel de dominio</div>

                                <Box sx={{ width: '100%' }}>
                                    <StyledSlider
                                        disabled={langLevelDisabled}
                                        value={langLevel}
                                        onChangeCommitted={onHandleChangeLangLevel}
                                        aria-label="Language Level Slider"
                                        defaultValue={1}
                                        min={1}
                                        max={filterCatalogData?.languageLevel?.length}
                                        step={1}
                                        valueLabelDisplay="off"
                                        sx={{ flexGrow: 1 }}
                                    />
                                </Box>

                                <div className="slider__marks">
                                    {filterCatalogData?.languageLevel.map(
                                        (
                                            { id, desc},
                                            index
                                        ) => (
                                            <div key={index} className={`slider__marks__${id}`}>
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="7"
                                                    height="6"
                                                    fill="#EE2B7B"
                                                    viewBox="0 0 7 6"
                                                >
                                                    <polygon points="0,6 3.5,0 7,6" />
                                                </svg>
                                                <p>{desc}</p>
                                            </div>
                                        )
                                    )}
                                </div>
                            </ContainerFilter>
                        );
                    }
                })}
            </div>
            <div className="list-filters-enc-tal__buttons">
                <Link
                    to="/empresas/encontrar_talento/"
                    className="list-filters-enc-tal__buttons__clean"
                    onClick={() => {
                        setSelectedFilters(initialSelectedFilters);
                        removeChecked();
                        removeCheckedRadio();
                    }}
                >
                    <button>Limpiar</button>
                </Link>

                <Button
                    onClickAction={handleFilters}
                    type="button"
                    text={"Aplicar"}
                    classname="list-filters-enc-tal__buttons__apply"
                    isDisabled={false}
                />
            </div>
        </div>
    );
};

export default ListFiltersEncTal;
